/**
 * Root class for all node material optimizers
 */
var NodeMaterialOptimizer = function () {
  function NodeMaterialOptimizer() {}
  /**
   * Function used to optimize a NodeMaterial graph
   * @param vertexOutputNodes defines the list of output nodes for the vertex shader
   * @param fragmentOutputNodes defines the list of output nodes for the fragment shader
   */


  NodeMaterialOptimizer.prototype.optimize = function (vertexOutputNodes, fragmentOutputNodes) {// Do nothing by default
  };

  return NodeMaterialOptimizer;
}();

export { NodeMaterialOptimizer };